import { observer } from 'mobx-react'
import React from 'react'

import {
   NavItemModel,
   UnionNavItemModel
} from '@flowwai-frontend/bps-officer-web/navbar-base'

import DefaultNavItem from '../DefaultNavItem/DefaultNavItem'

import * as Styles from './styles'

interface Props {
   templateNavItems: Array<UnionNavItemModel>
}

const NavbarTemplatesSection = (props: Props): React.ReactElement => {
   const { templateNavItems } = props

   const renderTemplateNavItem = (
      item: UnionNavItemModel
   ): React.ReactElement => {
      const isInstanceOfNavItem = item instanceof NavItemModel

      if (isInstanceOfNavItem) {
         const hasNoChildItems = !item.children.length

         if (hasNoChildItems) {
            return <DefaultNavItem key={item.id} item={item} />
         }
      }

      return <></>
   }

   return (
      <div className={Styles.containerStyles}>
         {templateNavItems.map(renderTemplateNavItem)}
      </div>
   )
}

export default observer(NavbarTemplatesSection)
